import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { SvgHelper } from "@app/shared";

@Component({
  selector: "[shadow-type-3]",
  templateUrl: "./shadow-type-3.component.html",
  styleUrl: "./shadow-type-3.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShadowType3Component {
  height = input<number>();

  shadowPoints = [
    291, 461, 150, 457, 179, 346, 238, 260, 360, 307, 402, 303, 493, 356,
  ];
  multiplier = 0.27;

  shadowPath = computed(() => {
    const delta = SvgHelper.calculateDelta(this.height(), this.multiplier);
    return SvgHelper.generateType2ShadowPath(delta, this.shadowPoints);
  });
}
